import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Fortuneronrentinpune() {



const cardData =
  {
    keyword: 'Fortuner On Rent in Pune',
    heading: 'Sanavi Travels: Fortuner On Rent in Pune',
    headingDescription: 'Sanavi Travels provides premium Fortuner On Rent in Pune for corporate travel, airport transfers, weddings, VIP transportation, family trips, sightseeing tours, and outstation journeys. The Toyota Fortuner is one of the most preferred luxury SUVs, known for its powerful performance, stylish design, spacious interiors, and exceptional comfort. Our Fortuner rental service in Pune is ideal for business executives, tourists, wedding guests, families, and travelers seeking a luxurious and reliable travel experience. Equipped with comfortable seating, powerful air conditioning, ample luggage space, and advanced safety features, the Fortuner ensures a smooth and enjoyable ride for both city and long-distance travel. Sanavi Travels offers well-maintained, fully insured, and professionally driven Fortuner vehicles for local Pune travel as well as outstation trips to Mumbai, Lonavala, Mahabaleshwar, Shirdi, Nashik, Goa, and other destinations. Whether you need a Fortuner Rental in Pune for a corporate event, family vacation, airport pickup, wedding function, or weekend getaway, we provide transparent pricing, flexible rental packages, experienced chauffeurs, and 24/7 customer support. With a commitment to comfort, safety, punctuality, and customer satisfaction, Sanavi Travels is a trusted choice for Fortuner Hire in Pune and luxury SUV rental services.',

    top: 'Popular Travel Uses for Fortuner On Rent in Pune',


"topPlaces": [
  {
    "title": "Fortuner for Airport Transfers in Pune",
    "description": "Fortuner is a preferred choice for Pune airport pickups and drops, especially for VIP travelers, corporate executives, and families carrying heavy luggage. The SUV offers ample boot space, high seating comfort, and smooth performance through city traffic, ensuring stress-free and punctual airport transfers. Travelers appreciate the commanding road presence and quiet cabin, which add a sense of luxury and confidence during airport travel, even during early morning or late-night hours."
  },
  {
    "title": "Fortuner for Railway Station Pickup and Drop",
    "description": "Passengers traveling to and from Pune railway stations often book Fortuner SUVs for their comfort, reliability, and convenience. The elevated seating position, spacious interiors, and easy entry-exit make Fortuner suitable for families, senior citizens, and business travelers. It ensures timely arrivals at stations while providing a relaxed and premium travel experience."
  },
  {
    "title": "Outstation Travel from Pune by Fortuner",
    "description": "Fortuner is highly suitable for outstation journeys from Pune to destinations such as Mumbai, Lonavala, Mahabaleshwar, Panchgani, Shirdi, Nashik, Kolhapur, Goa, and other long-distance locations. Its powerful engine, stable highway handling, and superior suspension make long journeys comfortable and fatigue-free. Families and groups prefer Fortuner for outstation trips due to safety, comfort, and performance on highways and hilly terrains."
  },
  {
    "title": "Wedding and Special Occasion Travel",
    "description": "For weddings and special occasions, Fortuner on rent in Pune is widely used for groom entry, family transportation, guest movement, and VIP travel. Its bold appearance, premium interiors, and luxury appeal make it a popular choice for weddings, receptions, and destination events, adding elegance and style to the occasion."
  },
  {
    "title": "Corporate and Executive Travel",
    "description": "Corporate clients frequently choose Fortuner for executive travel, business meetings, plant visits, conferences, and client transportation. The professional look, comfortable cabin, and smooth ride quality make Fortuner ideal for corporate use, ensuring a strong impression and reliable travel across Pune and industrial areas."
  },
  {
    "title": "Local Sightseeing in Pune",
    "description": "Tourists and families exploring Pune often prefer Fortuner for local sightseeing due to its comfort, spaciousness, and ability to handle city traffic smoothly. Whether visiting historical landmarks, temples, shopping hubs, or nearby attractions, Fortuner ensures a relaxed and premium sightseeing experience throughout the day."
  },
  {
    "title": "Family Vacations and Group Trips",
    "description": "Fortuner is ideal for family vacations and group trips where comfort, safety, and luggage space are essential. The SUV accommodates passengers comfortably while providing sufficient room for travel bags, making it suitable for long holidays and road trips from Pune."
  },
  {
    "title": "Highway and Ghat Section Travel",
    "description": "With excellent ground clearance and powerful performance, Fortuner performs exceptionally well on highways, expressways, and ghat sections. Travelers appreciate its stability, control, and smooth handling during long-distance drives from Pune."
  },
  {
    "title": "Luxury Personal and VIP Travel",
    "description": "For personal luxury travel and VIP movement, Fortuner offers exclusivity, comfort, and road dominance. It is often chosen for political visits, celebrity travel, and high-profile events."
  },
  {
    "title": "One-Day and Multi-Day SUV Rentals",
    "description": "Fortuner can be booked for one-day usage or extended multi-day travel plans, offering flexibility for short trips, weekend getaways, and long tours from Pune."
  }
]
,



"services": [
{
"name": "Fortuner On Rent in Pune",
"description": "Fortuner On Rent in Pune provides a premium SUV travel solution for families, corporate executives, tourists, and VIP travelers. Known for its powerful performance, luxury interiors, and superior comfort, Fortuner is ideal for airport transfers, weddings, corporate travel, sightseeing, and outstation journeys. Sanavi Travels ensures clean vehicles, professional chauffeurs, transparent pricing, and dependable service, delivering a stress-free and elite travel experience."
},
{
"name": "Fortuner SUV Hire Pune",
"description": "Fortuner SUV Hire Pune offers flexible rental options for local travel, outstation trips, executive movement, and special occasions. This service is preferred by customers who value luxury, safety, and performance while traveling in and around Pune."
},
{
"name": "AC Fortuner On Rent Pune",
"description": "AC Fortuner On Rent Pune ensures a cool, comfortable, and relaxing travel experience, especially during long journeys and summer travel. Air-conditioned cabins and premium interiors make it suitable for high-end travel requirements."
},
{
"name": "Non AC Fortuner Hire Pune",
"description": "Non AC Fortuner Hire Pune is available for customers seeking powerful SUV travel at relatively lower costs while maintaining comfort, safety, and reliability."
},
{
"name": "Fortuner for Airport Transfer Pune",
"description": "Fortuner for Airport Transfer Pune guarantees punctual pickups, spacious luggage handling, and smooth rides, making airport travel comfortable and stress-free."
},
{
"name": "Fortuner for Railway Pickup Pune",
"description": "Fortuner for Railway Pickup Pune ensures reliable and timely transfers with premium comfort, suitable for families and business travelers."
},
{
"name": "Fortuner for Wedding Pune",
"description": "Fortuner for Wedding Pune is widely used for groom entry, wedding guest travel, and family transportation, adding luxury and elegance to wedding functions."
},
{
"name": "Fortuner for Corporate Travel Pune",
"description": "Fortuner for Corporate Travel Pune supports executive travel, business meetings, plant visits, and client transportation with professionalism and style."
},
{
"name": "Fortuner for Outstation Pune",
"description": "Fortuner for Outstation Pune offers dependable long-distance travel with experienced drivers, powerful performance, and comfortable seating for extended journeys."
},
{
"name": "Affordable Fortuner Rental Pune",
"description": "Affordable Fortuner Rental Pune provides competitive pricing for premium SUV travel, offering excellent value without compromising on service quality."
},
{
"name": "Best Fortuner Cab Service Pune",
"description": "Best Fortuner Cab Service Pune by Sanavi Travels is trusted for reliability, vehicle quality, courteous drivers, and customer satisfaction."
},
{
"name": "Fortuner Hire with Driver Pune",
"description": "Fortuner Hire with Driver Pune includes skilled chauffeurs who manage routes, traffic, and schedules, ensuring a relaxed and safe journey."
},
{
"name": "Luxury Fortuner Hire Pune",
"description": "Luxury Fortuner Hire Pune delivers an exclusive SUV travel experience with premium vehicles and professional service for special occasions."
},
{
"name": "Fortuner for Family Trip Pune",
"description": "Fortuner for Family Trip Pune is ideal for family outings and vacations, offering comfort, safety, and ample space for luggage."
},
{
"name": "Fortuner for Local Sightseeing Pune",
"description": "Fortuner for Local Sightseeing Pune allows families and tourists to explore Pune comfortably while enjoying premium SUV travel."
}
],
"tableData": [
["Fortuner On Rent in Pune", "Fortuner SUV Hire Pune"],
["AC Fortuner Pune", "Non AC Fortuner Pune"],
["Fortuner Airport Cab Pune", "Fortuner Railway Pickup Pune"],
["Fortuner Wedding Cab Pune", "Fortuner Corporate Cab Pune"],
["Fortuner Outstation Cab Pune", "Fortuner Family Trip Pune"],
["Affordable Fortuner Pune", "Best Fortuner Cab Service Pune"],
["Luxury Fortuner Pune", "Fortuner with Driver Pune"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Fortuner On Rent in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers premium, reliable, and luxurious Fortuner rental services across Pune for all travel needs."
  },
  {
    "WhyChooseheading": "Powerful and Premium SUV",
    "WhyChoosedescription": "Toyota Fortuner provides superior performance, safety, and comfort on city roads and highways."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Trained chauffeurs ensure safe driving, route knowledge, and punctual service."
  },
  {
    "WhyChooseheading": "Transparent Pricing Structure",
    "WhyChoosedescription": "Clear and upfront pricing with no hidden charges ensures complete peace of mind."
  },
  {
    "WhyChooseheading": "Suitable for Multiple Travel Purposes",
    "WhyChoosedescription": "Ideal for airport, railway, wedding, corporate, sightseeing, and outstation travel."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Vehicles",
    "WhyChoosedescription": "All Fortuner SUVs are thoroughly cleaned and sanitized before every trip."
  },
  {
    "WhyChooseheading": "24/7 Booking and Support",
    "WhyChoosedescription": "Round-the-clock customer assistance for bookings and travel coordination."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "Guaranteed punctual pickups and smooth journey execution every time."
  }
]

}

const faqData = [
  {
    question: 'Do you provide Fortuner on rent in Pune?',
    answer: 'Yes, Sanavi Travels offers Fortuner on rent in Pune for various travel requirements.'
  },
  {
    question: 'Is Fortuner suitable for outstation travel?',
    answer: 'Yes, Fortuner is ideal for long-distance and outstation journeys.'
  },
  {
    question: 'Is driver included in Fortuner booking?',
    answer: 'Yes, all Fortuner rentals include experienced and professional drivers.'
  },
  {
    question: 'Can Fortuner be hired for weddings?',
    answer: 'Yes, Fortuner is widely used for weddings and special occasions.'
  },
  {
    question: 'Is Fortuner suitable for family trips?',
    answer: 'Yes, Fortuner is perfect for family travel due to its space and comfort.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vikram Pawar',
    feedback: 'Booked Fortuner in Pune for outstation travel. Powerful SUV and excellent service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Snehal Patil',
    feedback: 'Hired Fortuner for a wedding function. Very luxurious and comfortable experience.',
    rating: 5
  }
];




























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









// const jsonData = {
// "@context": "https://schema.org",
// "@type": "Service",
// "name": "Fortuner On Rent in Pune",
// "serviceType": "Fortuner Rental Service",
// "provider": {
// "@type": "LocalBusiness",
// "name": "Sanavi Travels",
// "telephone": "+91 7387507373"
// },
// "areaServed": {
// "@type": "City",
// "name": "Pune"
// },
// "description":
// "Book Fortuner on rent in Pune for weddings, corporate travel, airport transfers, family trips and outstation tours with professional drivers.",
// "aggregateRating": {
// "@type": "AggregateRating",
// "ratingValue": 4.7,
// "bestRating": 5,
// "worstRating": 1,
// "ratingCount": 10000
// }
// };



const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "@id":
    "https://www.sanavitravels.com/fortuner-on-rent-in-pune#service",

  "name": "Fortuner On Rent in Pune",

  "serviceType": "Toyota Fortuner Rental",

  "description":
    "Sanavi Travels offers Toyota Fortuner on rent in Pune for weddings, airport transfers, corporate travel, family trips, events and outstation journeys with professional driver.",

  "provider": {
    "@type": "LocalBusiness",
    "@id": "https://www.sanavitravels.com/#business",
    "name": "Sanavi Travels",
    "url": "https://www.sanavitravels.com/",
    "telephone": "+91-7387507373"
  },

  "areaServed": {
    "@type": "City",
    "name": "Pune",
    "containedInPlace": {
      "@type": "State",
      "name": "Maharashtra",
      "containedInPlace": {
        "@type": "Country",
        "name": "India"
      }
    }
  },

  "url":
    "https://www.sanavitravels.com/fortuner-on-rent-in-pune"
};






  return (
    <div>

<Helmet>
  <title>
    Fortuner On Rent in Pune | Toyota Fortuner Rental | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book a Toyota Fortuner on rent in Pune with Sanavi Travels for weddings, airport transfers, corporate travel, family trips and outstation journeys with a professional driver."
  />

  <meta
    name="keywords"
    content="Fortuner On Rent Pune, Fortuner Rental Pune, Fortuner Hire Pune, Toyota Fortuner Pune, Luxury SUV Rental Pune, Fortuner for Wedding Pune, Fortuner Cab Pune"
  />

  <link
    rel="canonical"
    href="https://www.sanavitravels.com/fortuner-on-rent-in-pune"
  />

  <meta
    property="og:type"
    content="website"
  />

  <meta
    property="og:title"
    content="Fortuner On Rent in Pune | Toyota Fortuner Rental | Sanavi Travels"
  />

  <meta
    property="og:description"
    content="Rent a Toyota Fortuner in Pune for weddings, airport transfers, corporate travel, family trips and outstation journeys with a professional driver."
  />

  <meta
    property="og:url"
    content="https://www.sanavitravels.com/fortuner-on-rent-in-pune"
  />

  <meta
    property="og:image"
    content="https://www.sanavitravels.com/images/fortuner-on-rent-in-pune.jpg"
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


{/* <Helmet>
  <title>
    Fortuner On Rent in Pune | Luxury SUV Rental Pune | Sanavi Travels
  </title>

<meta
 name="description"
 content="Book Fortuner On Rent in Pune with Sanavi Travels. Luxury SUV rental for weddings, airport transfers, corporate travel, family trips and outstation tours with driver."
/>

<meta
 name="keywords"
 content="Fortuner On Rent Pune, Fortuner Rental Pune, Fortuner Hire Pune, Toyota Fortuner Pune, Luxury SUV Rental Pune, Fortuner for Wedding Pune, Fortuner Cab Pune"
/>

  <link
    rel="canonical"
    href="https://www.sanavitravels.com/fortuner-on-rent-in-pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>

</Helmet> */}


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/fortuner-on-rent-in-pune.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Fortuneronrentinpune;